import { Row } from "antd";
import { Provider } from "./Provider";

type ProvidersProps = {
  data: any[];
  selectedItem: any;
  setSelectedItem: React.Dispatch<React.SetStateAction<any>>;
};

export const Providers = ({
  data,
  selectedItem,
  setSelectedItem,
}: ProvidersProps) => {
  return (
    <Row className="d-block mb-8">
      <p className="text w-500 mb-2 mt-0">Payment Methods</p>
      <Row className="align-center">
        {data.map((provider: any) => (
          <Provider
            key={provider.i}
            isSelected={provider.i === selectedItem?.i}
            data={provider}
            setSelectedItem={setSelectedItem}
          />
        ))}
      </Row>
    </Row>
  );
};
